var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLidarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03906 4.54755C5.03906 4.02948 5.45904 3.6095 5.97711 3.6095H14.1851C14.7031 3.6095 15.1231 4.02948 15.1231 4.54755V6.65816C15.1231 7.17624 14.7031 7.59622 14.1851 7.59622H13.5474C13.5731 7.70631 13.5792 7.82329 13.562 7.94292L13.3627 9.32868C13.2963 9.79042 12.9007 10.1332 12.4342 10.1332H12.367L12.3083 10.7358C12.2615 11.2164 11.8575 11.5829 11.3746 11.5829H8.78755C8.3047 11.5829 7.90073 11.2164 7.85392 10.7358L7.79522 10.1332H7.72798C7.26149 10.1332 6.86587 9.79042 6.79948 9.32868L6.60022 7.94292C6.58302 7.82329 6.58909 7.70631 6.61478 7.59622H5.97711C5.45904 7.59622 5.03906 7.17624 5.03906 6.65816V4.54755Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2519 7.3617H14.1851C14.5736 7.3617 14.8886 7.04672 14.8886 6.65816V4.54755C14.8886 4.15899 14.5736 3.84401 14.1851 3.84401H5.97711C5.58856 3.84401 5.27358 4.15899 5.27358 4.54755V6.65816C5.27358 7.04672 5.58856 7.3617 5.97711 7.3617H6.91029L6.84316 7.64949C6.82401 7.73158 6.81935 7.81918 6.83235 7.90954L7.03161 9.2953C7.0814 9.64161 7.37811 9.89871 7.72798 9.89871H8.008L8.08733 10.7131C8.12243 11.0735 8.42541 11.3484 8.78755 11.3484H11.3746C11.7368 11.3484 12.0397 11.0735 12.0749 10.7131L12.1542 9.89871H12.4342C12.7841 9.89871 13.0808 9.64161 13.1306 9.2953L13.3298 7.90954C13.3428 7.81918 13.3382 7.73158 13.319 7.64949L13.2519 7.3617ZM14.1851 7.59622C14.7031 7.59622 15.1231 7.17624 15.1231 6.65816V4.54755C15.1231 4.02948 14.7031 3.6095 14.1851 3.6095H5.97711C5.45904 3.6095 5.03906 4.02948 5.03906 4.54755V6.65816C5.03906 7.17624 5.45904 7.59622 5.97711 7.59622H6.61478C6.59719 7.67161 6.5888 7.75024 6.59078 7.83073C6.59169 7.86777 6.5948 7.90521 6.60022 7.94292L6.79948 9.32868C6.86587 9.79042 7.26149 10.1332 7.72798 10.1332H7.79522L7.85392 10.7358C7.90073 11.2164 8.3047 11.5829 8.78755 11.5829H11.3746C11.8575 11.5829 12.2615 11.2164 12.3083 10.7358L12.367 10.1332H12.4342C12.9007 10.1332 13.2963 9.79042 13.3627 9.32868L13.562 7.94292C13.5674 7.90521 13.5705 7.86777 13.5714 7.83073C13.5734 7.75024 13.565 7.67161 13.5474 7.59622H14.1851Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64551 15.5317L5.1632 5.21313L5.38517 5.28881L1.86748 15.6074L1.64551 15.5317Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5171 15.533L15.1167 5.21448L14.8939 5.28788L18.2944 15.6064L18.5171 15.533Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45835 16.2731H1.05127L1.75481 15.5696L2.45835 16.2731Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75566 15.4039L2.74228 16.3905H0.769043L1.75566 15.4039ZM1.33521 16.156H2.17612L1.75566 15.7356L1.33521 16.156Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7845 15.3353H9.37744L10.081 14.6317L10.7845 15.3353Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0804 14.4657L11.067 15.4523H9.09375L10.0804 14.4657ZM9.65991 15.2178H10.5008L10.0804 14.7973L9.65991 15.2178Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9925 16.0387H17.5854L18.289 15.3352L18.9925 16.0387Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2884 15.1693L19.275 16.1559H17.3018L18.2884 15.1693ZM17.8679 15.9214H18.7088L18.2884 15.501L17.8679 15.9214Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96289 14.7489V11.4657H10.1974V14.7489H9.96289Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6464 10.1756L8.18152 10.763L8.1514 10.9956L3.61628 10.4082L3.6464 10.1756Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6464 10.1756L8.18152 10.763L8.1514 10.9956L3.61628 10.4082L3.6464 10.1756Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5943 10.1756L12.0592 10.763L12.0893 10.9956L16.6244 10.4082L16.5943 10.1756Z",
    fill: "#1E2447"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLidarIcon);
export default __webpack_public_path__ + "static/media/LidarIcon.e2220206.svg";
export { ForwardRef as ReactComponent };